<section class="w-full h-full bg-[#FAFAFA] md:px-10 md:py-16 px-4 py-8 overflow-x-hidden">
  <div class="container mx-auto h-full w-full">
    <div
      class="flex md:flex-row flex-col justify-evenly gap-14 md:gap-0 items-center h-full w-full"
    >
      <!-- <div
        appScrollAnimate="animate-move-in-right"
        [scrollThreshold]="0"
        class="h-full flex items-center justify-center max-md:w-full"
      >
        <div
          class="w-56 h-96 rounded-2xl overflow-hidden mt-14 mr-[-30px]"
          appScrollAnimate="animate-move-in-right"
          [scrollThreshold]="0"
        >
          <img
            src="flexible_image/flexible_2.jpg"
            alt="Flexible Image"
            class="w-full h-full object-cover"
          />
        </div>
        <div
          class="w-56 h-96 rounded-2xl overflow-hidden mb-14"
          appScrollAnimate="animate-move-in-right"
          [scrollThreshold]="0"
        >
          <img
            src="flexible_image/flexible_1.jpg"
            alt="Flexible Image"
            class="w-full h-full object-cover"
          />
        </div>
      </div> -->
      <div
        appScrollAnimate="animate-move-in-right"
        [scrollThreshold]="0"
        class="max-md:w-full w-1/2 h-full rounded-2xl overflow-hidden"
      >
        <img
          src="flexible_image/feature.jpg"
          alt="Flexible Image"
          class="w-full h-full object-cover"
        />
      </div>

      <div
        appScrollAnimate="animate-move-in-left"
        [scrollThreshold]="0"
        class="flex flex-col items-start justify-start gap-4"
      >
        <h2
          i18n="flexible|Easy and flexible heading@@flexible.title"
          class="md:text-3xl text-2xl font-bold text-black"
        >
          Easy & Flexible
        </h2>
        <ul class="flex flex-col items-start justify-start gap-2">
          <li>
            <p
              i18n="flexible|Booking in advance feature@@flexible.bookingInAdvance"
              class="text-main-green text-sm md:text-base font-medium"
            >
              <img src="check.svg" alt="Check" class="inline-block mr-2" /> Booking In Advance
            </p>
          </li>
          <li>
            <p
              i18n="flexible|Easy to pay feature@@flexible.easyToPay"
              class="text-main-green text-sm md:text-base font-medium"
            >
              <img src="check.svg" alt="Check" class="inline-block mr-2" /> Easy To Pay
            </p>
          </li>
          <li>
            <p
              i18n="flexible|No download needed feature@@flexible.noDownload"
              class="text-black text-sm md:text-base font-medium"
            >
              <img src="close.svg" alt="Close" class="inline-block mr-2" /> No Application Download
              Needed
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
